import React from "react";

import AlignToHorizontal from "./AlignToHorizontal";
import AlignToVertical from "./AlignToVertical";
import AlignToBottom from "./AlignToBottom";
import AlignToTop from "./AlignToTop";
import AlignToLeft from "./AlignToLeft";
import AlignToRight from "./AlignToRight";

const AlignToProduct = ({
  handleAlignToLeft,
  handleAlignToRight,
  handleAlignToTop,
  handleAlignToBottom,
  handleAlignToHorizontal,
  handleAlignToVertical,
}) => {
  return (
    <div className="tool tool--alignitems">
      <h4 className="tool__header">Align To Product</h4>
      <div className="tool__options">
        <AlignToHorizontal handleAlignToHorizontal={handleAlignToHorizontal} />
        <AlignToVertical handleAlignToVertical={handleAlignToVertical} />
        <AlignToBottom handleAlignToBottom={handleAlignToBottom} />
        <AlignToTop handleAlignToTop={handleAlignToTop} />
        <AlignToLeft handleAlignToLeft={handleAlignToLeft} />
        <AlignToRight handleAlignToRight={handleAlignToRight} />
      </div>
    </div>
  );
};
export default AlignToProduct;
